import React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {fetchUserSessions, resetUserSessions} from "../../../creators/user.sessions";
import DateSince from "../../components/Date";
import "./UserIpList.scss";

class UserIpList extends React.Component {

    componentDidMount() {
        if(this.props.userId){
            this.props.fetchUserSessions(this.props.userId);
        }

    }

    componentWillUnmount() {
        this.props.resetUserSessions();
    }

    render() {
        return (
            <div id="user-ip-list">
                <div className="container">
                    <div className="card">
                        <div className={"ip-list"}>
                            <ul className={"row-ip"}>
                                <li>IP</li>
                                <li>Derniere connexion</li>
                            </ul>
                            {this.props.userSessions.map(session =>(
                                <ul key={session._id} className={"row-ip"}>
                                    <li>{session.ip}</li>
                                    <li><DateSince
                                        date={session.createdAt}
                                        prefix={false}
                                        currentFormat={true} /></li>
                                </ul>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userSessions: state.userSessions.data,
        userSessionsLoading: state.userSessions.loading,
        userSessionsInitialized: state.userSessions.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserSessions,
    resetUserSessions
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserIpList);